export const SET_MARKETING_PAGE = 'SET_MARKETING_PAGE'; //eslint-disable-line



// WEBPACK FOOTER //
// ./app/actions/marketing.js